export enum TableSortDirection {
  EMPTY,
  ASCENDING,
  DESCENDING,
}
